(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-swipe-recommendations"] && !Shopify.designMode) return;
  try {
    
  class MobileSwipeRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.recommendationsPerformed === 'true') {
        this.initializeCarousel();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.loadRecommendations();
        },
        { rootMargin: '0px 0px 240px 0px' }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }

    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;

        const html = document.createElement('div');
        html.innerHTML = await response.text();
        const replacement = html.querySelector(`#${CSS.escape(this.id)}`);

        if (!replacement?.innerHTML.trim()) {
          this.remove();
          return;
        }

        this.innerHTML = replacement.innerHTML;
        this.dataset.recommendationsPerformed = 'true';
        this.initializeCarousel();
      } catch {
        this.remove();
      }
    }

    initializeCarousel() {
      const track = this.querySelector('[data-msr-track]');
      const previous = this.querySelector('[data-msr-previous]');
      const next = this.querySelector('[data-msr-next]');

      if (!track || !previous || !next) return;

      const step = () => track.clientWidth + 12;
      const updateControls = () => {
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };

      previous.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateControls, { passive: true });
      this.resizeObserver = new ResizeObserver(updateControls);
      this.resizeObserver.observe(track);
      updateControls();
    }
  }

  if (!customElements.get('mobile-swipe-recommendations')) {
    customElements.define('mobile-swipe-recommendations', MobileSwipeRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
